import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import { Form } from 'react-bootstrap';
import styles from 'components/transactionEditor/ActionButtons.module.css';
import { XmlNamespaceItem } from 'components/transactionEditor/BodyMatchersList';
import _ from 'lodash';
import BzmIcon from '../../icons/BzmIcon';

interface XmlNamespaceProps {
  id: string;
  xmlNamespaceItem: XmlNamespaceItem;
  onChange: (name: string, value: string, id: string) => void;
  onDelete: () => void;
  onAdd: () => void;
  displayAdd: boolean;
  isReadOnly?: boolean;
}

const XmlNamespace = (props: XmlNamespaceProps) => {
  const { t } = useTranslation('transactions');

  const handleChange = (e: any, id: string) => {
    const target = e.target as HTMLInputElement;
    props.onChange(target.name, target.value, id);
  };

  return (
    <div id="xml-namespace">
      <Row>
        <Col md={5}>
          <Form.Group>
            <Form.Label htmlFor={`qa-xml-namespace-prefix-${props.id}`}>
              {t('transactions:editor.xmlNamespacePrefix')}
            </Form.Label>
            <Form.Control
              placeholder={'prefix'}
              disabled={props.isReadOnly}
              as="input"
              name="prefix"
              id={'qa-xml-namespace-prefix-' + props.id}
              value={props.xmlNamespaceItem.prefix ? props.xmlNamespaceItem.prefix : ''}
              onChange={(event: any) => handleChange(event, props.id)}
            />
          </Form.Group>
        </Col>
        <Col md={5}>
          <Form.Group>
            <Form.Label htmlFor={`qa-xml-namespace-uri-${props.id}`}>
              {t('transactions:editor.xmlNamespaceUri')}
            </Form.Label>
            <Form.Control
              placeholder={'uri'}
              disabled={props.isReadOnly}
              as="input"
              name="uri"
              id={'qa-xml-namespace-uri-' + props.id}
              value={props.xmlNamespaceItem.uri ? props.xmlNamespaceItem.uri : ''}
              onChange={(event: any) => handleChange(event, props.id)}
            />
          </Form.Group>
        </Col>
        <Col>
          <div className={styles.actionButtons}>
            <Button
              disabled={props.isReadOnly}
              id={'qa-btn-delete-xml-namespace-' + _.uniqueId()}
              onClick={props.onDelete}
              variant="danger"
              className="btn btn-danger btn-circular"
              title={t('editor.deleteXmlNamespace')}
            >
              <BzmIcon variant={'icon-bzm-delete'} />
            </Button>
            {props.displayAdd && (
              <Button
                disabled={props.isReadOnly}
                id={'qa-btn-add-xml-namespace-' + _.uniqueId()}
                onClick={props.onAdd}
                variant="secondary"
                className="btn-circular ml-4"
                title={t('editor.addXmlNamespace')}
              >
                <BzmIcon variant={'icon-bzm-add'} className={'icon-theme-blue'} />
              </Button>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default XmlNamespace;
